import './BottomButton.scss';

const BottomButton = ({
  onClick,
  disabled = false,
  children,
  variant = 'primary',
}) => {
  return (
    <button
      className="bottomButton text_white font_bold "
      onClick={onClick}
      disabled={disabled}
      data-variant={variant}
    >
      {children}
    </button>
  );
};

export default BottomButton;
